/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains if the current page should be indexed.
 */
export const indexContextKey = "index";
